<template>
  <div class="setting-form">
    <UserTitle title="编辑基本资料"></UserTitle>
    <b-form @submit="onSubmit" class="form-view">
      <b-row>
        <b-col cols="12" md="6" class="form-left-view">
          <b-form-group
            id="name"
            label-for="name"
            label="昵称"
            class="user-input"
          >
            <b-form-input
              id="input-name"
              v-model="form.nickname"
              placeholder="昵称"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="weixin"
            label-for="weixin"
            label="微信号"
            class="user-input"
          >
            <b-form-input
              id="input-weixin"
              v-model="form.info.weixin"
              placeholder="微信"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <b-form-group
            id="email"
            label-for="email"
            label="邮箱"
            class="user-input"
          >
            <b-form-input
              id="input-email"
              v-model="form.info.email"
              placeholder="邮箱"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <hr />
        <b-button class="success-button usually-button" type="submit"
          >保存</b-button
        >
        <b-button @click="goBack" class="disable-button usually-button"
          >取消</b-button
        >
      </b-row>
    </b-form>
  </div>
</template>
<script>
import Api from "@/apis";
export default {
  data() {
    return {
      form: {
        nickname: "",
        // phone: "",
        info: {
          weixin: "",
          email: ""
        }
      }
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    async getUser() {
      try {
        const data = await Api.User.getUser();
        this.form.nickname = data.nickname || "";
        this.form.info.weixin = data.info.weixin || "";
        this.form.info.email = data.info.email || "";
      } catch (e) {
        this.$message.error(e);
      }
    },
    async onSubmit(event) {
      event.preventDefault();
      try {
        let query = this.form;
        const data = await Api.User.EditUser(query);
        if (data) {
          this.$message.success("修改成功");
          this.$router.go(-1);
        }
      } catch (e) {
        this.$message.error(e, "修改失败");
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.setting-form .user-all-titie {
  margin-left: 34px;
  margin-right: 34px;
}
</style>
